import { useCallback } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { ValkyrieDefaultsEditor } from 'config-editor';
import type { ValkyrieLambdaDefaults } from 'config-editor-common';
import { useObjectField } from '../fieldState';

type Props = FieldExtensionComponentProps<ValkyrieLambdaDefaults>;

export function ValkyrieLambdaDefaultsEditor(props: Props) {
  const fallback = useCallback(
    (): ValkyrieLambdaDefaults => ({
      lambda_source: '',
      build_number: 'latest',
      s3_key: '',
      timeout: 24,
      memory_size: 1024,
      env_vars: {},
    }),
    [],
  );

  const { value, commit } = useObjectField(props, { fallback });

  return <ValkyrieDefaultsEditor defaults={value} onChange={commit} />;
}
